module.exports = __webpack_public_path__ + "static/media/shipping-timed.ce79bcbc.svg";